/**
 * Created by PursuitStar on 2019/03/12
 * Desc: 超级会员项目路由表配置
 */
const _import = require('./_import_' + process.env.NODE_ENV);
const superMemberProjectRoute = [
    {
        path: '/dataCenter',
        name: 'dataCenter',
        component: _import('superMember/dataCenter/index'),
        hidden: true,
        title: '数据中心'
    },
    {
        path: '/selfWallet',
        name: 'selfWallet',
        component: _import('superMember/selfWallet/index'),
        hidden: true,
        title: '我的钱包'
    },
    {
        path: '/incomeAndExpense/:type',
        name: 'incomeAndExpense',
        component: _import('superMember/incomeAndExpense/index'),
        hidden: true,
        title: '收支明细'
    },
    {
        path: '/accountDetail/:id',
        name: 'accountDetail',
        component: _import('superMember/accountDetail/index'),
        hidden: true,
        title: '账单详情'
    },
    {
        path: '/applyGetMoney',
        name: 'applyGetMoney',
        component: _import('superMember/applyGetMoney/index'),
        hidden: true,
        title: '申请提现'
    },
    {
        path: '/transactWallet/:isUseQuickPay',
        name: 'transactWallet',
        component: _import('superMember/transactWallet/index'),
        hidden: true,
        title: '开通钱包'
    },
    {
        path: '/verifyAccountPhone',
        name: 'verifyAccountPhone',
        component: _import('superMember/verifyAccountPhone/index'),
        hidden: true,
        title: '验证账户手机'
    },
    {
        path: '/progressingMoney',
        name: 'progressingMoney',
        component: _import('superMember/progressingMoney/index'),
        hidden: true,
        title: '在途资金'
    },
    {
        path: '/moneyDetail/:id',
        name: 'moneyDetail',
        component: _import('superMember/moneyDetail/index'),
        hidden: true,
        title: '资金详情'
    },
    {
        path: '/getMoneyRecord',
        name: 'getMoneyRecord',
        component: _import('superMember/getMoneyRecord/index'),
        hidden: true,
        title: '提现记录'
    },
    {
        path: '/treeEnlist',
        name: 'treeEnlist',
        component: _import('superMember/treeEnlist/index'),
        hidden: true,
        title: '英小树招募和我的收益'
    },
    { path: '/treeList', name: 'treeList', component: _import('superMember/treeList/index'), hidden: true, title: '英小树列表' },
    {
        path: '/treelistDetail',
        name: 'treelistDetail',
        component: _import('superMember/treelistDetail/index'),
        hidden: true,
        title: '英小树详情'
    },

    // { 
    //     path: '/superPersonal',
    //     name:'superPersonal', 
    //     component: _import('superMember/superPersonal/index'), 
    //     hidden: true ,
    //     title:'超级会员个人中心'
    // },

    //账户相关页面
    // {
    //   path: '/accountSafe',
    //   name: 'accountSafe',
    //   component: _import('superMember/accountSafe/index'),
    //   hidden: true,
    //   title: '账户安全'
    // },
    {
        path: '/internetBank',
        name: 'internetBank',
        component: _import('superMember/internetBank/index'),
        hidden: true,
        title: '网银支付页面'
    },
    {
        path: '/accountManage',
        name: 'accountManage',
        component: _import('superMember/accountManage/index'),
        hidden: true,
        title: '账户管理'
    },
    {
        path: '/amentNumber',
        name: 'amentNumber',
        component: _import('superMember/amentNumber/index'),
        hidden: true,
        title: '更换手机号'
    },
    {
        path: '/noteAment',
        name: 'noteAment',
        component: _import('superMember/noteAment/index'),
        hidden: true,
        title: '修改交易密码--短信验证'
    },
    {
        path: '/oldPasswordAment',
        name: 'oldPasswordAment',
        component: _import('superMember/oldPasswordAment/index'),
        hidden: true,
        title: '修改交易密码',
        meta: { title: '修改交易密码' }
    },

    /* =================== 银行卡相关页面 =================== */
    { 
        path: '/bankList', 
        name: 'bankList', 
        component: _import('superMember/bankList/index'), 
        hidden: true, 
        title: '银行卡列表' 
    },
    {
        path: '/suggestBank',
        name: 'suggestBank',
        component: _import('superMember/suggestBank/index'),
        hidden: true,
        title: '推荐银行卡'
    },
    {
        path: '/chooseBank',
        name: 'chooseBank',
        component: _import('superMember/chooseBank/index'),
        hidden: true,
        title: '选择银行卡'
    },
    { 
        path: '/keyBank', 
        name: 'keyBank', 
        component: _import('superMember/keyBank/index'), 
        hidden: true, 
        title: '激活银行卡' 
    },
    {
        path: '/cardDetail',
        name: 'cardDetail',
        component: _import('superMember/cardDetail/index'),
        hidden: true,
        title: '卡片详情'
    },
    { 
        path: '/addBank', 
        name: 'addBank', 
        component: _import('superMember/addBank/index'), 
        hidden: true, 
        title: '添加银行卡' 
    },
    {
        path: '/addBankCardAgain',
        name: 'addBankCardAgain',
        component: _import('superMember/addBankCardAgain/index'),
        hidden: true,
        title: '二次添加银行卡'
    },

    /* =================== 帮助中心相关页面 =================== */
    {
        path: '/helpCenter',
        name: 'helpCenter',
        component: _import('superMember/helpCenter/index'),
        hidden: true,
        title: '帮助中心'
    },
    {
        path: '/helpDetail',
        name: 'helpDetail',
        component: _import('superMember/helpDetail/index'),
        hidden: true,
        title: '帮助详情'
    },
    /* =================== 成功页相关页面 =================== */
    {
        path: '/orderSuccess',
        name: 'orderSuccess',
        component: _import('superMember/orderSuccess/index'),
        hidden: true,
        title: '订单支付成功页'
    },
    {
        path: '/giftBagSuccess',
        name: 'giftBagSuccess',
        component: _import('superMember/giftBagSuccess/index'),
        hidden: true,
        title: '首次购买英树礼包成功页'
    },
    {
        path: '/functionSuccess',
        name: 'functionSuccess',
        component: _import('superMember/functionSuccess/index'),
        hidden: true,
        title: '申请开通钱包功能成功页'
    },
    {
        path: '/withdrawSuccess',
        name: 'withdrawSuccess',
        component: _import('superMember/withdrawSuccess/index'),
        hidden: true,
        title: '提现结果页'
    },
    {
        path: '/fullSuccess',
        name: 'fullSuccess',
        component: _import('superMember/fullSuccess/index'),
        hidden: true,
        title: '充值结果页'
    },
    /* =================== 充值相关页面 =================== */
    {
        path: '/rechargeWallet',
        name: 'rechargeWallet',
        component: _import('superMember/rechargeWallet/index'),
        hidden: true,
        title: '充值钱包'
    },
    {
        path: '/rechargeRecord',
        name: 'rechargeRecord',
        component: _import('superMember/rechargeRecord/index'),
        hidden: true,
        title: '充值记录'
    },
    {
        path: '/confirmPayment',
        name: 'confirmPayment',
        component: _import('superMember/confirmPayment/index'),
        hidden: true,
        title: '确认付款'
    },

    // 超级会员小迭代
    // {
    //   path: '/openAccountAgree',
    //   name: 'openAccountAgree',
    //     component: _import('superMember/openAccountAgree/index'),
    //   hidden: true,
    //   title: '开通账户协议',
    // },
    {
        path: '/addMember',
        name: 'addMember',
        component: _import('superMember/addMember/index'),
        hidden: true,
        title: '添加会员',
        meta: { title: '添加会员' }
    },
    {
        path: '/myTeam',
        component: _import('superMember/myTeam/index'),
        hidden: true,
        title: '我的团队',
        children: [
            { 
                path: '', 
                name: 'myTeam', 
                component: _import('superMember/teamMember/index'), 
                hidden: true, title: '我的团队会员' 
            },
            {
                path: 'smallTree',
                name: 'smallTree',
                component: _import('superMember/teamSmallTree/index'),
                hidden: true,
                title: '我的团队英小树'
            },
        ]
    },

    // { 
    //     path: '/confirmPayment',
    //     name:'confirmPayment', 
    //     component: _import('superMember/confirmPayment/index'), 
    //     hidden: true ,
    //     title:'确认付款'
    // },
    //经销商首页
    // { 
    //     path: '/agentHomepage',
    //     name:'agentHomepage', 
    //     component: _import('superMember/agentHomepage/index'), 
    //     hidden: true,
    //     title:"经销商首页"
    // },
]

export default superMemberProjectRoute;


// WEBPACK FOOTER //
// ./src/router/superMemberProject.js